/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Alert,
  Container,
  Label,
  FormGroup,
} from "reactstrap";
import { getToken } from "../../utils/user";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import FormUpload from "./FormUpload";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";
import axios from "axios";

import { useHistory } from "react-router-dom";

const Category = () => {
  const history = useHistory();
  let token = getToken();

  const [category, setCategory] = useState({
    name: "",
    description: "",
    categoryId: "",
  });
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState("");

  const { name, description, categoryId } = category;

  const handleSubmit = async (event) => {
    setLoading(true);
    event.preventDefault();
    if (image) {
      form.set("image", image);
    }
    try {
      let resp = await axios.post(process.env.REACT_APP_BACKEND_URL+"/category", form, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setLoading(false);
      if (resp.data.message) {
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          history.push("/categories");
        }, 3000);
        setError(false);
        setCategory({
          name: "",
          description: "",
        });
        setForm(new FormData());
      }
    } catch (err) {
      setLoading(false);
      setSuccess(false);
      setError(err.response.data.error);
      setTimeout(() => {
        setError(false);
      }, 3000);
    }
  };

  const getCategories = async () => {
    const resp = await axios.get(process.env.REACT_APP_BACKEND_URL+"/category/all", {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (resp.data.message) {
      setCategories(resp.data.categories);
    }
  };

  useEffect(() => {
    document.body.classList.add("auth-body-bg");
    setForm(new FormData());
    getCategories();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Create Category"
            breadcrumbItems={[
              { title: "Dashboard", link: "/" },
              { title: "Create Category", link: "/category" },
            ]}
          />

          {/* <div className="home-btn d-none d-sm-block">
            <Link to="/"><i className="mdi mdi-home-variant h2 text-white"></i></Link>
        </div>*/}
          <div>
            <Container fluid className="p-0">
              <Row className="no-gutters">
                <Col lg={2}></Col>
                <Col lg={8}>
                  <div className="p-4 d-flex">
                    <div className="w-100">
                      <Row className="justify-content-center">
                        <Col lg={9}>
                          <div>
                            <div className="text-center">
                              {/*  <div>
                                                    <Link to="#" className="logo"><img src={logodark} height="20" alt="logo"/></Link>
                                                </div>*/}

                              <h4 className="font-size-18 mt-4">
                                Create Category
                              </h4>
                            </div>

                            {success && (
                              <Alert color="success">
                                Category created Successfully.
                              </Alert>
                            )}

                            {error && <Alert color="danger">{error}</Alert>}

                            <div className="p-2 mt-5">
                              <AvForm
                                onValidSubmit={handleSubmit}
                                className="form-horizontal"
                              >
                                <FormGroup className="auth-form-group-custom mb-4">
                                  <i className="ri-file-list-line auti-custom-input-icon"></i>
                                  <Label htmlFor="name">Category Name</Label>
                                  <AvField
                                    name="name"
                                    value={name}
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    placeholder="Enter Category Name"
                                    onChange={(e) => {
                                      form.set("name", e.target.value);
                                      setCategory({
                                        ...category,
                                        name: e.target.value,
                                      });
                                    }}
                                  />
                                </FormGroup>

                                <FormGroup className="auth-form-group-custom mb-4">
                                  <i
                                    className="ri-layout-6-line auti-custom-input-icon"
                                    style={{ top: "25%" }}
                                  ></i>
                                  <Label htmlFor="description">
                                    Description
                                  </Label>
                                  <AvField
                                    name="description"
                                    value={description}
                                    type="textarea"
                                    className="form-control"
                                    id="description"
                                    placeholder="Enter Description"
                                    onChange={(e) => {
                                      form.set("description", e.target.value);
                                      setCategory({
                                        ...category,
                                        description: e.target.value,
                                      });
                                    }}
                                    style={{ height: 120 }}
                                  />
                                </FormGroup>
                                <FormGroup className="auth-form-group-custom mb-4">
                                  <i className="ri-medal-line auti-custom-input-icon"></i>
                                  <Label htmlFor="role">Parent Category</Label>
                                  <AvField
                                    name="role"
                                    value={categoryId}
                                    type="select"
                                    className="form-control"
                                    id="role"
                                    placeholder="Enter Parent Category"
                                    onChange={(e) => {
                                      form.set("categoryId", e.target.value);
                                      setCategory({
                                        ...category,
                                        categoryId: e.target.value,
                                      });
                                    }}
                                  >
                                    <option>Select Parent Category</option>
                                    {categories &&
                                      categories.map((v) => {
                                        return (
                                          <option value={v._id}>
                                            {v.name}
                                          </option>
                                        );
                                      })}
                                  </AvField>
                                </FormGroup>
                                <FormUpload setImage={setImage} />

                                <div className="text-center">
                                  <Button
                                    color="primary"
                                    className="mt-1 w-md waves-effect waves-light"
                                    type="submit"
                                  >
                                    {loading ? "Loading ..." : "Create"}
                                  </Button>
                                </div>

                                {/*<div className="mt-4 text-center">
                                                        <p className="mb-0">By registering you agree to the Template <Link to="#" className="text-primary">Terms of Use</Link></p>
                                                    </div>*/}
                              </AvForm>
                            </div>

                            {/*<div className="mt-5 text-center">
                                                <p>Already have an account ? <Link to="/login" className="font-weight-medium text-primary"> Login</Link> </p>
                                                <p>© 2020 Template. Crafted with <i className="mdi mdi-heart text-danger"></i> by Themesdesign</p>
                                            </div>*/}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
                <Col lg={2}></Col>
                {/*<Col lg={7}>
                        <div className="authentication-bg">
                            <div className="bg-overlay"></div>
                        </div>
                    </Col>*/}
              </Row>
            </Container>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Category;
